import {
	addBulkAddresses,
	AddressDataUpdateType,
	AddressImportType,
	AddressItemType,
	useBulkUpdateAddressData,
} from '@ukpostbox/client-data';
import { BulkAddressesAddedResponseType } from '@ukpostbox/client-data/lib/Types/Response/AddressResponseTypes';
import { Colour, useNotifications } from '@ukpostbox/frontend-framework';
import { FieldValues, FormProvider, useForm } from '@ukpostbox/frontend-framework/lib/ReactHookForm';
import React, { memo, useState } from 'react';
import { faAddressBook } from '@fortawesome/pro-solid-svg-icons/faAddressBook';
import AddressImporterResults from './AddressImporterResults';

type AddressImporterFormType = {
	addressData: any;
	embeddedForm?: boolean;
	savedCallback?: any;
	removeCallback?: any;
};

const AddressImporterForm = memo((props: AddressImporterFormType) => {
	const { AddNotification } = useNotifications();

	const [addressError, setAddressError] = useState<any>();
	const [addressSaving, setAddressSaving] = useState<boolean>(false);

	const formMethods = useForm({
		mode: 'onChange',
	});

	const updateAddressData = useBulkUpdateAddressData();

	const HandleSave = (data: FieldValues) => {
		setAddressSaving(true);

		const mutateUiAddressData: Array<AddressItemType> = [];

		addBulkAddresses(data as Array<AddressImportType>)
			.then((r: BulkAddressesAddedResponseType) => {
				if (r.addresses.length === 0) {
					AddNotification({
						title: data.Addresses.length === 1 ? 'Address Already Exists' : 'Addresses Already Exist',
						icon: faAddressBook,
						colour: Colour.Alert,
					});
				} else {
					r.addresses.forEach((addressResult) => {
						mutateUiAddressData.push({
							object: {
								addressId: addressResult.addressId,
								name: addressResult.name,
								businessName: addressResult.businessName,
								propertyName: addressResult.propertyName,
								addressLine1: addressResult.addressLine1,
								addressLine2: addressResult.addressLine2,
								addressLine3: addressResult.addressLine3,
								postCode: addressResult.postCode,
								countryCode: addressResult.countryCode,
								emailAddress: addressResult.emailAddress,
								phoneNo: addressResult.phoneNo,
							},
							label: addressResult.addressString || '',
							value: addressResult.addressId,
						});
					});

					updateAddressData
						.mutateAsync({
							newData: mutateUiAddressData,
							updateType: AddressDataUpdateType.CREATE,
						})
						.then(() => {
							if (props.savedCallback) {
								props.savedCallback(mutateUiAddressData);
							}
						});

					AddNotification({
						title: `Imported ${r.addresses.length} ${r.addresses.length === 1 ? 'Address' : 'Addresses'}!`,
						icon: faAddressBook,
						colour: Colour.Success,
					});
				}
			})
			.catch((e) => {
				setAddressError(e.toString());
				AddNotification({
					title: 'Address Import Failed',
					icon: faAddressBook,
					colour: Colour.Alert,
				});
			})
			.finally(() => {
				setAddressSaving(false);
			});
	};

	return (
		<FormProvider {...formMethods}>
			<form onSubmit={formMethods.handleSubmit((data: FieldValues) => HandleSave(data))}>
				<fieldset disabled={addressSaving} className='address-importer-rows'>
					<AddressImporterResults
						addressData={props.addressData}
						embeddedForm={props.embeddedForm}
						removeCallback={props.removeCallback}
					/>
				</fieldset>
			</form>
		</FormProvider>
	);
});

export default AddressImporterForm;
